import React from "react";
import { SearchHeader } from "~assets/frontend/frame/frm-search/components/SearchHeader";
import { SearchBody } from "~assets/frontend/frame/frm-search/components/SearchBody";
import { SearchButton } from "~assets/frontend/frame/frm-search/components/SearchButton";
import { SearchInput } from "~assets/frontend/frame/frm-search/components/SearchInput";
import Translator from "bazinga-translator";
import { createPortal } from "react-dom";
import { useQuery, useResults, useSearchActions, useShowHeader } from "~assets/frontend/frame/frm-search/store/SearchStore";
export const FrameSearch = () => {
    var _a;
    const query = useQuery();
    const showHeader = useShowHeader();
    const results = useResults();
    const { toggleHeader, closeSearch, handleSearchInput } = useSearchActions();
    const suggestions = results === null ? [] : [...new Set(results.facets.map((facet) => facet.suggestions).flat(1))];
    return (React.createElement(React.Fragment, null,
        React.createElement(SearchButton, { onClick: (event) => {
                toggleHeader(true);
            } }),
        showHeader &&
            createPortal(React.createElement("div", { role: "dialog", "aria-label": Translator.trans("frm-search.search-dialog", {}, "frontend"), tabIndex: -1, className: `${query || results ? "bg-white" : ""} fixed left-0 right-0 top-0 z-search mx-auto h-screen overflow-auto` },
                React.createElement("div", { role: "search" },
                    React.createElement(SearchHeader, { onClose: closeSearch },
                        React.createElement(SearchInput, { value: query, placeholder: Translator.trans("frm-search.placeholder", {}, "frontend"), suggestions: suggestions, onInput: handleSearchInput })),
                    React.createElement(SearchBody, null))), (_a = document.getElementById("storybook-document-body")) !== null && _a !== void 0 ? _a : document.body)));
};
